import { useMemo } from "react";
import dateFnsFormat from "date-fns/format";
import enUS from "date-fns/locale/en-US";
import es from "date-fns/locale/es";
import ptBR from "date-fns/locale/pt-BR";

import { useLanguage } from "./useLanguage";

export const useDateLocale = () => {
    const { language } = useLanguage();

    const dateLocale = useMemo(() => {
        switch (language) {
            case "en_US":
                return enUS;
            case "es":
                return es;
            default:
                return ptBR;
        }
    }, [language]);

    const formatDate = (date: string | Date | undefined, format: string) => {
        if (!date) {
            return "";
        }

        const _date = new Date(date);

        return dateFnsFormat(_date, format, { locale: dateLocale });
    };

    return { formatDate };
};
